<template functional>
    <b-container v-bind="data.attrs"  :class="[data.staticClass, data.class]" fluid>
        <slot></slot>
    </b-container>
</template>

<script>
    export default {
        name: "BasePage",
    };
</script>

<style scoped>

</style>